import { EditorContent } from '@tiptap/react';
import classNames from 'classnames';

import { tipTapPluginsMode, tipTapSize } from '../constants';
import { useEditorSetup } from '../hooks';

import { EditorToolbar } from './EditorToolbar';
import { Popover } from './Popover';

import './Tiptap.scss';

export type TiptapPropsType = {
  content?: string;
  onChange?: any;
  editable?: boolean;
  placeholder?: string;
  pluginsMode: tipTapPluginsMode;
  size?: tipTapSize;
  withPopover?: boolean;
  debugMode?: boolean;
  isRichText?: boolean;
  isHtmlMode?: boolean;
  isOnFocus?: boolean;
  limitTagCodes?: string[];
};

export const Tiptap = ({
  content = '',
  onChange,
  editable = true,
  placeholder = 'Type something here...',
  withPopover = false,
  debugMode = false,
  pluginsMode = tipTapPluginsMode.text,
  size = tipTapSize.medium,
  isRichText = false,
  isHtmlMode = false,
  isOnFocus = false,
}: TiptapPropsType) => {
  const editor = useEditorSetup({
    content,
    editable,
    placeholder,
    pluginsMode,
    isHtmlMode,
    isOnFocus,
    onChange,
  });

  return (
    <div className={classNames('rich-editor', { 'is-richtext': isRichText })}>
      <div className="white-card">
        {isRichText && <EditorToolbar editor={editor} pluginsMode={pluginsMode} />}
        {withPopover && <Popover editor={editor} />}
        <EditorContent
          editor={editor}
          className={classNames('editable-content', { 'is-medium': size === tipTapSize.medium })}
        />
      </div>
      {debugMode && (
        <>
          <h2>Text (tiptap)</h2>
          <div className="white-card">
            <pre>{editor.getText()}</pre>
          </div>
          <h2>HTML Output</h2>
          <div className="white-card">
            <pre>{editor.getHTML()}</pre>
          </div>
        </>
      )}
    </div>
  );
};
